import React, { useContext } from 'react';
import { ButtonBack } from '../../common/Button/ButtonBack';
import { Link, useNavigate } from 'react-router-dom';
import { SiteContext } from '../../../context/SiteContext';
import Links from '../../common/Widgets/Links';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { PageAbsolutePath } from '../../../consts/Common';

const TermsAndConditions = (): JSX.Element => {
  const navigate = useNavigate();

  const { site } = useContext(SiteContext);

  const { brand } = site;

  const { brandDisplayName, brandPhoneNumbers } = brand;

  const { claimsNumber } = brandPhoneNumbers;

  const goBack = (): void => {
    navigate(-1);
  };

  const chevronLeftComponent = <FontAwesomeIcon icon={faChevronLeft} />;

  return (
    <div className='terms-conditions'>
      <Links
        id='back-link'
        title=''
        items={[{ to: '', text: 'Back', onClick: goBack }]}
        icon={chevronLeftComponent}
      />
      <h2>Excess Return Voucher Terms and conditions</h2>
      <ol>
        <li>
          The voucher is valid for one year from its start date and can only be
          used once. Only one voucher can be issued per vehicle. Only one
          voucher can be redeemed per claim.
        </li>
        <li>
          The voucher is not valid for standalone glass claims, misfuelling
          claims, Motability vehicles or where your car is used for racing, or
          driven on any kind of race track including the Nürburgring in Germany.
        </li>
        <li>
          The voucher only applies when the claim is reported to, accepted and
          managed by the {brandDisplayName} Excess Return team and the accident
          repair is carried out at our approved repairer.
        </li>
        <li>
          Following an accident, regardless of who you are insured with, you
          must call the {brandDisplayName} Excess Return team first on the
          dedicated{' '}
          <a className='in-text' href={`tel:${claimsNumber}`}>
            {claimsNumber}
          </a>{' '}
          number. If you call any other number or your insurer first, or without
          our instruction, the voucher will be void.
        </li>
        <li>
          Where we accept and complete the vehicle repair, we will pay up to the
          voucher value* as cash back towards any policy excess paid by you. You
          will be required to pay the repairer your applicable Motor Insurance
          Policy Excess. The repair cost must be settled by your insurer. Once
          the repair is completed and your insurer has settled the claim, we
          will refund you the voucher value* or the value of your excess
          whichever is the lower. You will need to provide proof that you have
          paid your excess in order to claim on the voucher. Nothing in this
          offer obliges us to accept any vehicle for repair. The voucher is not
          valid if your vehicle is deemed a total loss.
        </li>
        <li>
          Where we manage the vehicle repair, we will do so in conjunction with
          your motor insurer if the accident was your fault, or the other
          driver’s insurer if they were at-fault and if they have accepted
          liability. Some insurers may charge an additional excess for using our
          repairers.
        </li>
        <li>
          Accident recovery is provided for unroadworthy vehicles when you call
          the {brandDisplayName} Excess Return team first and we handle your
          insurance claim on your behalf. If you cancel the recovery of your
          vehicle you will be liable for any cancellation charges incurred, or
          if your insurer rejects your claim you will be liable for any recovery
          costs incurred.
        </li>
        <li>
          A replacement car is provided subject to availability for the duration
          of the accident repair carried out by our approved repairer when you
          call the {brandDisplayName} Excess Return team first and we handle
          your insurance claim on your behalf. We will provide a repairer
          courtesy car if the incident is your fault, or if the incident is not
          your fault, we will aim to provide a hire car of a similar size to
          your own vehicle. A replacement car is not available for standalone
          glass claims or if you are claiming on {brandDisplayName} Free
          Driveaway Insurance.
        </li>
        <li>
          In some instances where your insurer may not let us report the claim
          to them on your behalf, we will ask you to report to them advising
          that you are using our {brandDisplayName} Excess Return service with
          our approved repairer.
        </li>
        <li>This offer may be withdrawn at any time.</li>
        <li>
          The voucher must be active before the incident occurs in order to be
          valid. The incident must take place between the validity dates shown
          on the voucher.
        </li>
      </ol>
      <p>
        The {brandDisplayName} Excess Return Voucher is provided by Car Care
        Plan Limited which is registered in England, Company No. 850195 at
        Jubilee House, 5 Midpoint Business Park, Thornbury, West Yorkshire, BD3
        7AG. To understand how we may process your information read our{' '}
        <Link
          className='in-text'
          to={PageAbsolutePath.Insurance.FairUseNoticePage}>
          Fair Use Notice.
        </Link>
      </p>
      <p>*The voucher value as stated on your Excess Return Voucher.</p>
      <div className='flex-row'>
        <ButtonBack
          name='btnBack'
          text='Back'
          onClick={goBack}
          additionalClassNames='btn-back'
        />
      </div>
    </div>
  );
};

export default TermsAndConditions;
